import React, { useEffect, useState } from "react";
import api, { fmtINR, fmtDate } from "@/lib/api";

export default function AgentCollections() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/agent/collections").then((r) => setList(r.data)); }, []);
  const total = list.reduce((a, b) => a + (parseFloat(b.amount) || 0), 0);
  return (
    <div data-testid="agent-collections-page">
      <h1 className="text-2xl font-extrabold tracking-tight">Collection Report</h1>
      <p className="text-sm text-slate-500">{list.length} entries · Total {fmtINR(total)}</p>

      <div className="mt-5 bg-white border border-slate-100 rounded-2xl card-shadow table-scroll">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500 font-bold">
            <tr><th className="text-left p-3">Customer</th><th className="text-right p-3">Amount</th><th className="text-right p-3">Method</th><th className="text-right p-3">Date</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {list.map((c) => (
              <tr key={c.id} data-testid={`coll-row-${c.id}`}>
                <td className="p-3 font-bold">{c.customer_name}</td>
                <td className="p-3 text-right font-extrabold text-emerald-600">{fmtINR(c.amount)}</td>
                <td className="p-3 text-right text-slate-500 capitalize">{c.method}</td>
                <td className="p-3 text-right text-slate-500 text-xs">{fmtDate(c.created_at)}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-slate-400">No collections yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
